export function initEnvs() {
  (window as any).__envs = {
    NEXT_PUBLIC_API_HOST: process.env.NEXT_PUBLIC_API_HOST,
    NEXT_PUBLIC_STATS_API_HOST: process.env.NEXT_PUBLIC_STATS_API_HOST,
    NEXT_PUBLIC_NETWORK_NAME: process.env.NEXT_PUBLIC_NETWORK_NAME,
    NEXT_PUBLIC_NETWORK_ID: process.env.NEXT_PUBLIC_NETWORK_ID,
    NEXT_PUBLIC_NETWORK_RPC_URL: process.env.NEXT_PUBLIC_NETWORK_RPC_URL,
    NEXT_PUBLIC_NETWORK_CURRENCY_NAME:
      process.env.NEXT_PUBLIC_NETWORK_CURRENCY_NAME,
    NEXT_PUBLIC_NETWORK_CURRENCY_SYMBOL:
      process.env.NEXT_PUBLIC_NETWORK_CURRENCY_SYMBOL,
    NEXT_PUBLIC_NETWORK_CURRENCY_DECIMALS:
      process.env.NEXT_PUBLIC_NETWORK_CURRENCY_DECIMALS,
    NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID:
      process.env.NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID,
    NEXT_PUBLIC_MARKETPLACE_ENABLED:
      process.env.NEXT_PUBLIC_MARKETPLACE_ENABLED,
  };
}
